import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from '../config/routes';
import { PrivateRoute } from '../features/auth/PrivateRoute';
import { LoginPage } from '../features/auth/LoginPage';
import { AuthCallback } from '../features/auth/AuthCallback';
import { ControlPanel } from '../features/owner/ControlPanel';
import { AccountConfig } from '../features/owner/AccountConfig';
import { Enter } from '../features/guest/Enter';
import { Room } from '../features/guest/Room';
import { ThankYou } from '../features/guest/ThankYou';
import { Cooldown } from '../features/guest/Cooldown';
import { ErrorPage } from '../features/guest/ErrorPage';

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.AUTH_CALLBACK} element={<AuthCallback />} />
        <Route path={ROUTES.ENTER} element={<Enter />} />
        <Route path={ROUTES.ROOM_PATTERN} element={<Room />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path={ROUTES.COOLDOWN} element={<Cooldown />} />
        <Route path={ROUTES.GRACIAS} element={<ThankYou />} />
        <Route
          path={ROUTES.CONTROL}
          element={
            <PrivateRoute>
              <ControlPanel />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.ACCOUNT_CONFIG_PATTERN}
          element={
            <PrivateRoute>
              <AccountConfig />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to={ROUTES.CONTROL} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
